import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Table, Modal } from 'react-bootstrap';
import Toggle from '../../component_library/Toggle';
import './updateModal.css';

export default function UpdateRepertoireModal(props) {
  const [tracksToUpdate, setTracksToUpdate] = useState([]);

  const toggleAllState = useMemo(() => {
    try {
      if (!props.data.Tracks) {
        return false;
      }

      return tracksToUpdate.length === props.data.Tracks.length;
    } catch (err) {
      return false;
    }
  }, [props.data.Tracks, tracksToUpdate]);

  const handleToggle = trackId => {
    let tracks = [];
    if (tracksToUpdate.includes(trackId)) {
      tracks = tracksToUpdate.filter(x => x !== trackId);
    } else {
      tracks = [...tracksToUpdate, trackId];
    }
    setTracksToUpdate(tracks);
  };

  const handleToggleUpload = useCallback(() => {
    if (toggleAllState) {
      setTracksToUpdate([]);
    } else {
      toggleAll();
    }
  }, [toggleAllState]);

  const toggleAll = useCallback(() => {
    if (props.data.Tracks && props.data.Tracks.length > 0) {
      const tracks = props.data.Tracks;
      const tracksId = tracks.map(x => x.TrackId);
      setTracksToUpdate(tracksId);
    }
  }, [props.data]);

  useEffect(() => {
    toggleAll();
  }, [props.data.Tracks]);

  const trackDataTable = trackData => {
    return (
      <Table className="responsive">
        <thead>
          <tr>
            <th className="custom-width-upload">
              <div>
                <Toggle
                  value={toggleAllState}
                  checked={toggleAllState}
                  onChange={() => {
                    handleToggleUpload();
                  }}
                />
                <p>Update</p>
              </div>
            </th>
            <th className="custom-width-trackdata">Track Data</th>
            <th className="custom-width-id">Track #</th>
            <th className="custom-width-artist-track">Track Name</th>
            <th className="custom-width-artist-track">Artist</th>
            <th>ISRC</th>
          </tr>
        </thead>
        {trackData.map((item, i) => {
          return (
            <tbody>
              <tr>
                <td></td>
                <td>WAS</td>
                <td>{item.TrackId}</td>
                <td>{item.was.trackTitle}</td>
                <td>{item.was.artist}</td>
                <td>{item.was.isrc}</td>
              </tr>
              <tr>
                <td>
                  <Toggle
                    defaultChecked={tracksToUpdate.includes(item.TrackId)}
                    checked={tracksToUpdate.includes(item.TrackId)}
                    onChange={() => {
                      handleToggle(item.TrackId);
                    }}
                  />
                </td>
                <td>UPDATE TO</td>
                <td>{item.TrackId}</td>
                <td className="updated-text-clr">{item.updatedTo.trackTitle}</td>
                <td className="updated-text-clr">{item.updatedTo.artist}</td>
                <td className="updated-text-clr">{item.updatedTo.isrc}</td>
              </tr>
            </tbody>
          );
        })}
      </Table>
    );
  };
  const rightDataTable = rightData => {
    return (
      <Table className="responsive">
        <thead>
          <tr>
            <th className="custom-width-data">Right Data</th>
            <th className="custom-width-id">Track #</th>
            <th>Has Rights</th>
          </tr>
        </thead>
        {rightData.map((item, i) => {
          return (
            <tbody>
              <tr>
                <td>WAS</td>
                <td>{item.TrackId}</td>
                <td>{item.was}</td>
              </tr>
              <tr>
                <td>UPDATED TO</td>
                <td>{item.TrackId}</td>
                <td className="updated-text-clr">{item.updatedTo}</td>
              </tr>
            </tbody>
          );
        })}
      </Table>
    );
  };
  return (
    <Modal
      scrollable={true}
      dialogClassName="update-modal-70w"
      close
      id="updateModal"
      show={props.show}
    >
      <Modal.Header>
        <Modal.Title>Project Updates</Modal.Title>
        <p className="sub-title">
          We’ve found updates to the following project data within UMG’s systems.{' '}
        </p>
      </Modal.Header>
      <Modal.Body>
        <p className="note">
          Updates have been found for your project. Tracks with sliders on (blue) will be updated,
          switch the slider off (grey) to skip.
        </p>
        {props.data.Tracks && props.data.Tracks.length > 0 && trackDataTable(props.data.Tracks)}
        <br></br>
        {props.data.Rights && props.data.Rights.length > 0 && rightDataTable(props.data.Rights)}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" id="yesButton" onClick={() => props.handleClose(tracksToUpdate)}>
          Confirm Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
